export default __webpack_public_path__ + "static/group-features-ad665404d5a52cbc2d39f1c8329e8e2f.mp4";